import React, { useState } from 'react';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import api from '../../utils/api';

const B = '#0B3D6E', T = '#0F6E56';

export default function AdminUsers() {
  const qc = useQueryClient();
  const [search, setSearch] = useState('');
  const [planFilter, setPlanFilter] = useState('');

  const { data, isLoading } = useQuery({
    queryKey: ['admin-users', search, planFilter],
    queryFn: () => api.get('/admin/users', { params:{ role:'client', search:search||undefined, plan:planFilter||undefined } }).then(r=>r.data)
  });

  const toggleMutation = useMutation({
    mutationFn: id => api.put(`/admin/users/${id}/toggle`),
    onSuccess: () => { toast.success('Compte mis à jour'); qc.invalidateQueries(['admin-users']); },
    onError: () => toast.error('Erreur')
  });

  const planMutation = useMutation({
    mutationFn: ({ id, plan }) => api.put(`/admin/users/${id}/plan`, { plan }),
    onSuccess: () => { toast.success('Plan mis à jour'); qc.invalidateQueries(['admin-users']); },
    onError: () => toast.error('Erreur')
  });

  const users = data?.data || [];

  return (
    <div style={{ padding:'1.5rem', maxWidth:1100, margin:'0 auto' }}>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'1.5rem', flexWrap:'wrap', gap:10 }}>
        <div>
          <h1 style={{ fontSize:20, fontWeight:600, marginBottom:2 }}>Clients StockMed</h1>
          <div style={{ fontSize:13, color:'#64748b' }}>{users.length} client(s) enregistré(s)</div>
        </div>
      </div>

      {/* Stats */}
      <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(140px,1fr))', gap:12, marginBottom:'1.5rem' }}>
        {[
          { label:'Total clients', value:users.length, bg:'#E6F1FB', color:B, icon:'👥' },
          { label:'Plan Gratuit',  value:users.filter(u=>u.plan==='free').length, bg:'#f1f5f9', color:'#64748b', icon:'🆓' },
          { label:'Plan Pro',      value:users.filter(u=>u.plan==='pro').length, bg:'#fef3c7', color:'#d97706', icon:'⭐' },
          { label:'Comptes actifs',value:users.filter(u=>u.isActive).length, bg:'#E1F5EE', color:T, icon:'✅' },
        ].map(k=>(
          <div key={k.label} style={{ background:'#fff', border:'1px solid #e2e8f0', borderRadius:12, padding:'1rem', boxShadow:'0 1px 4px rgba(0,0,0,0.06)' }}>
            <div style={{ fontSize:16, marginBottom:6 }}>{k.icon}</div>
            <div style={{ fontSize:22, fontWeight:600, color:k.color }}>{k.value}</div>
            <div style={{ fontSize:11, color:'#64748b' }}>{k.label}</div>
          </div>
        ))}
      </div>

      {/* Filters */}
      <div style={{ display:'flex', gap:10, marginBottom:'1rem', flexWrap:'wrap' }}>
        <input type="text" placeholder="Rechercher client, email, établissement..." value={search} onChange={e=>setSearch(e.target.value)}
          style={{ flex:1, minWidth:180, border:'1px solid #e2e8f0', borderRadius:8, padding:'8px 12px', fontSize:13, outline:'none', background:'#f8fafc' }}/>
        <select value={planFilter} onChange={e=>setPlanFilter(e.target.value)} style={{ border:'1px solid #e2e8f0', borderRadius:8, padding:'8px 12px', fontSize:13, outline:'none', background:'#f8fafc', cursor:'pointer' }}>
          <option value="">Tous les plans</option>
          <option value="free">Plan Gratuit</option>
          <option value="pro">Plan Pro</option>
        </select>
      </div>

      <div style={{ background:'#fff', border:'1px solid #e2e8f0', borderRadius:12, overflow:'hidden', boxShadow:'0 1px 4px rgba(0,0,0,0.06)' }}>
        {isLoading ? <div style={{ padding:'3rem', textAlign:'center', color:'#94a3b8' }}>Chargement...</div> : (
          <div style={{ overflowX:'auto' }}>
            <table style={{ width:'100%', borderCollapse:'collapse', minWidth:650 }}>
              <thead>
                <tr style={{ background:'#f8fafc' }}>
                  {['Client','Établissement','Email','Plan','Inscrit le','Statut','Actions'].map(h=>(
                    <th key={h} style={{ textAlign:'left', fontSize:11, fontWeight:600, color:'#64748b', textTransform:'uppercase', letterSpacing:'0.5px', padding:'10px 14px', whiteSpace:'nowrap' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {users.map(u=>(
                  <tr key={u._id} style={{ borderTop:'1px solid #f1f5f9' }}
                    onMouseEnter={e=>e.currentTarget.style.background='#fafafa'}
                    onMouseLeave={e=>e.currentTarget.style.background='transparent'}>
                    <td style={{ padding:'10px 14px' }}>
                      <div style={{ fontSize:13, fontWeight:600 }}>{u.firstName||''} {u.lastName||u.username}</div>
                      <div style={{ fontSize:11, color:'#94a3b8' }}>@{u.username}</div>
                    </td>
                    <td style={{ padding:'10px 14px' }}>
                      <div style={{ fontSize:13 }}>{u.company||'—'}</div>
                      {u.companyType && <div style={{ fontSize:11, color:'#94a3b8' }}>{u.companyType}</div>}
                    </td>
                    <td style={{ padding:'10px 14px', fontSize:12, color:'#64748b' }}>{u.email}</td>
                    <td style={{ padding:'10px 14px' }}>
                      <span style={{ background:u.plan==='pro'?'#fef3c7':'#f1f5f9', color:u.plan==='pro'?'#d97706':'#64748b', fontSize:11, fontWeight:600, padding:'3px 9px', borderRadius:8 }}>
                        {u.plan==='pro'?'⭐ Pro':'🆓 Gratuit'}
                      </span>
                    </td>
                    <td style={{ padding:'10px 14px', fontSize:12, color:'#94a3b8', whiteSpace:'nowrap' }}>{new Date(u.createdAt).toLocaleDateString('fr-FR')}</td>
                    <td style={{ padding:'10px 14px' }}>
                      <span style={{ background:u.isActive?'#E1F5EE':'#fee2e2', color:u.isActive?T:'#dc2626', fontSize:11, fontWeight:600, padding:'3px 9px', borderRadius:8 }}>
                        {u.isActive?'Actif':'Inactif'}
                      </span>
                    </td>
                    <td style={{ padding:'10px 14px' }}>
                      <div style={{ display:'flex', gap:5, flexWrap:'wrap' }}>
                        <button onClick={()=>toggleMutation.mutate(u._id)} style={{ fontSize:11, background:'#f1f5f9', border:'1px solid #e2e8f0', padding:'4px 8px', borderRadius:6, cursor:'pointer', whiteSpace:'nowrap' }}>
                          {u.isActive?'Désactiver':'Activer'}
                        </button>
                        <button onClick={()=>planMutation.mutate({ id:u._id, plan:u.plan==='pro'?'free':'pro' })} style={{ fontSize:11, background:u.plan==='pro'?'#f1f5f9':'#fef3c7', border:`1px solid ${u.plan==='pro'?'#e2e8f0':'#fcd34d'}`, padding:'4px 8px', borderRadius:6, cursor:'pointer', whiteSpace:'nowrap', color:u.plan==='pro'?'#64748b':'#d97706' }}>
                          {u.plan==='pro'?'→ Gratuit':'→ Pro ⭐'}
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {users.length===0 && <div style={{ textAlign:'center', padding:'3rem', color:'#94a3b8' }}>Aucun client trouvé</div>}
          </div>
        )}
      </div>
    </div>
  );
}

